import { fanEntries } from "@/mocks/homeData";
import SectionHeading from "./SectionHeading";
import TagChip from "./TagChip";

export default function FanSection() {
  return (
    <section id="fan" className="w-full bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-6">
        <SectionHeading
          eyebrow="同人创作"
          title="漂亮的小姨子同人：五类读者二次创作"
          desc="同人是衍生内容里最活跃的一块，形式和风格都相当发散。下面按载体分类，方便你按自己想看的媒介快速定位。"
        />

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {fanEntries.map((entry, index) => (
            <article
              key={entry.id}
              className={`flex flex-col rounded-lg border p-5 md:p-6 ${
                index === 0 ? "border-primary-200 bg-primary-50 sm:col-span-1" : "border-background-200 bg-background-100"
              }`}
            >
              <span
                className={`w-11 h-11 flex items-center justify-center rounded-md text-xl ${
                  index === 0 ? "bg-primary-500 text-background-50" : "bg-secondary-100 text-secondary-900"
                }`}
              >
                <i className={entry.icon}></i>
              </span>
              <h3 className="mt-4 font-heading text-lg font-semibold text-foreground-950">{entry.title}</h3>
              <p className="text-xs md:text-sm text-foreground-500 mt-0.5">{entry.subtitle}</p>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600 flex-1">{entry.desc}</p>
              <div className="mt-4 flex flex-wrap gap-2">
                {entry.tags.map((tag) => (
                  <TagChip key={tag} variant={index === 0 ? "primary" : "default"}>
                    {tag}
                  </TagChip>
                ))}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}